<template>
  <div >
    <base-header
      class="header pb-0 pt-5 pt-lg-8 d-flex align-items-center bg-success"
      style="min-height: 50px; background-size: cover; background-position: center top;"
    >
      <!-- Mask -->
      <span class="bg-gradient-default opacity-8" />
      <!-- Header container -->
    </base-header>
    <!-- Max Hashtag Limit Management -->
    <div class="m-4">
      <h5>Max Hashtag Limit</h5>
      <div class="d-flex align-items-center mb-2">
        <span class="mr-2">Current Limit:</span>
        <strong class="mr-3">{{ maxHashtagLimit !== null ? maxHashtagLimit : 'Loading...' }}</strong>
        <input
          type="number"
          v-model="newLimit"
          class="form-control mr-2"
          style="max-width: 120px;"
          placeholder="Set new limit"
        />
        <button class="btn btn-primary" @click="setMaxHashtagLimit" :disabled="!newLimit">Set Limit</button>
      </div>
    </div>
    <!-- Search & Filter Hashtags -->
    <div class="mb-4 d-flex align-items-center gap-2">
      <input
        type="text"
        class="form-control mr-2"
        style="max-width: 250px;"
        placeholder="Search hashtags..."
        v-model="search"
        @input="searchHashtags"
      />
      <select 
        id="daysFilter" 
        class="form-control mr-2" 
        style="max-width: 150px;"
        v-model="daysFilter"
        @change="loadHashtags"
      >
        <option value="7">7 days</option>
        <option value="14">14 days</option>
        <option value="30">30 days</option>
        <option value="90">90 days</option>
        <option value="0">All time</option>
      </select>
      <button class="btn btn-secondary" @click="resetFilters">Reset Filters</button>
    </div>
    <!-- Hashtag Table -->
    <div class="table-responsive">
      <table class="table table-hover">
        <thead>
          <tr>
            <th>Hashtag</th>
            <th>Created</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="hashtags.length === 0">
            <td colspan="5" class="text-center py-4">No hashtags found.</td>
          </tr>
          <tr v-for="tag in hashtags" :key="tag.hashtag_id">
            <td><strong>#{{ tag.tag }}</strong></td>
  
            <!-- Status cell removed -->
            <td>{{ formatDate(tag.created_at) }}</td>
            <td>
              <button class="btn btn-danger btn-sm" @click="confirmDeleteTag(tag)">
                Delete
              </button>
            </td>
    <!-- Delete Confirmation Modal -->
    <div v-if="showDeleteModal" class="modal fade show" tabindex="-1" style="display: block; background: rgba(0,0,0,0.4);">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Confirm Delete</h5>
            <button type="button" class="close" @click="showDeleteModal = false">
              <span>&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p>Are you sure you want to delete the hashtag <strong>#{{ tagToDelete && tagToDelete.tag }}</strong>?</p>
          </div>
          <div class="modal-footer">
            <button class="btn btn-secondary" @click="showDeleteModal = false">Cancel</button>
            <button class="btn btn-danger" @click="deleteTagConfirmed">Delete</button>
          </div>
        </div>
      </div>
    </div>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "HashtagManager",
  data() {
    return {
      hashtags: [],
      search: "",
      daysFilter: "7",
      newHashtag: "",
      isAdding: false,
      addError: "",
      maxHashtagLimit: null,
      newLimit: "",
      auth: {
        headers: {
          "Content-Type": "application/json",
          "Authorization": "nabnee#" + localStorage.getItem("accessToken"),
          "_id": localStorage.getItem("_id"),
        },
      },
      showDeleteModal: false,
      tagToDelete: null,
    };
  },
  mounted() {
    this.loadHashtags();
    this.fetchMaxHashtagLimit();
  },
  methods: {
    confirmDeleteTag(tag) {
      this.tagToDelete = tag;
      this.showDeleteModal = true;
    },
    deleteTagConfirmed() {
      if (!this.tagToDelete) return;
      const payload = {
        tag_id: this.tagToDelete._id
      };
        // Optimistically remove the tag from the UI
  this.hashtags = this.hashtags.filter(tag => tag._id !== this.tagToDelete._id);
  this.showDeleteModal = false;
  this.tagToDelete = null;
  
      axios
        .post(
          process.env.VUE_APP_API_ENDPOINT + "delete_tag",
          payload,
          this.auth
        )
        .then(() => {
          this.fetchHashtags();
          this.showDeleteModal = false;
          this.tagToDelete = null;
        })
        .catch(() => {
          this.showDeleteModal = false;
          this.tagToDelete = null;
        });
    },
    fetchMaxHashtagLimit() {
      axios
        .get(
          process.env.VUE_APP_API_ENDPOINT + "get_max_hashtag_limit",
          {},
          this.auth
        )
        .then((res) => {
          this.maxHashtagLimit = typeof res.data.max_hashtag_limit !== 'undefined' ? res.data.max_hashtag_limit : null;
        })
        .catch(() => {
          this.maxHashtagLimit = null;
        });
    },
    setMaxHashtagLimit() {
      if (!this.newLimit) return;
      axios
        .post(
          process.env.VUE_APP_API_ENDPOINT + "set_max_hashtag_limit",
          { max_hashtag_limit: this.newLimit },
          this.auth
        )
        .then(() => {
          this.fetchMaxHashtagLimit();
          this.newLimit = "";
        });
    },
    loadHashtags() {
      // Support filtering by days
      const payload = {};
      if (this.daysFilter && this.daysFilter !== "0") {
        const days = parseInt(this.daysFilter);
        const since = new Date();
        since.setDate(since.getDate() - days);
        payload.since = since.toISOString();
      }
      axios
        .post(
          process.env.VUE_APP_API_ENDPOINT + "read_tag_all",
          payload,
          this.auth
        )
        .then((res) => {
          this.hashtags = res.data.details || [];
        });
    },
    createHashtag() {
      if (!this.newHashtag) return;
      this.isAdding = true;
      this.addError = "";
      const payload = { tag: this.newHashtag.trim().toLowerCase() };
      axios
        .post(
          process.env.VUE_APP_API_ENDPOINT + "create_tag",
          payload,
          this.auth
        )
        .then((res) => {
          this.isAdding = false;
          if (res.data && res.data.success === false) {
            this.addError = res.data.error || res.data.message || "Error adding hashtag.";
            return;
          }
          this.newHashtag = "";
          if (res.data && res.data.message) {
            this.$toast && this.$toast(res.data.message);
          }
          this.fetchHashtags();
        })
        .catch((err) => {
          this.isAdding = false;
          if (err.response && err.response.data && err.response.data.error) {
            this.addError = err.response.data.error;
          } else {
            this.addError = "Error adding hashtag.";
          }
        });
    },
    searchHashtags() {
      // Use loadHashtags and filter client-side for search
      this.loadHashtags();
      if (this.search) {
        this.hashtags = this.hashtags.filter(tag =>
          tag.tag && tag.tag.includes(this.search.trim().toLowerCase())
        );
      }
    },

    resetFilters() {
      this.search = "";
      this.daysFilter = "7";
      this.loadHashtags();
    },
    toggleStatus(tag) {
      const payload = { tag_id: tag.tag_id, status: tag.status === "approved" ? "blocked" : "approved" };
      axios
        .post(
          process.env.VUE_APP_API_ENDPOINT + "update_tag",
          payload,
          this.auth
        )
        .then(() => {
          this.fetchHashtags();
        });
    },
    // deleteTag is now handled by confirmDeleteTag and deleteTagConfirmed
    formatDate(dateString) {
      if (!dateString) return "";
      try {
        const date = new Date(dateString);
        return date.toLocaleDateString("en-US", {
          year: "numeric",
          month: "short",
          day: "numeric",
        });
      } catch (e) {
        return dateString;
      }
    },
  },
};
</script>
<style scoped>
.hashtag-manager-page {
  padding-left: 32px;
}
</style>